<template>
  <div>
    <div v-for="(ex, i) in expireDates">
      <div class="input-group">
        <div v-if="allToSelectDate" class="input-group-append">
          <button type="button" :disabled="!ex.id && !ex.saved" @click="selectNewDate(ex.date)"
                  :class="{'btn btn-default': true, 'active btn-outline-primary': !!selectedDates[ex.date]}">
            =>
          </button>
        </div>
        <input v-mask="dateMask" @change="updateRecord('expireDate')" type="text"
               v-model="ex.format_date" :disabled="disableEdit && (ex.id || ex.saved)" placeholder="...."
               class="form-control"/>
        <div v-if="i === 0" class="input-group-append">
          <button @click="addNewDate()" class="btn btn-outline-success btn-xs">
            <i class="icon-fa icon-fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import moment from 'moment';

export default {
  props: ['expireDates', 'drugId', 'revisionId', 'invoiceId', 'invoices', 'updateDates', 'savedDates', 'allToSelectDate', 'disableEdit'],
  data() {
    return {
      selectedDates: {},
      // expireMask: [/[0-1]/, '#.', /[2-2]/, /[0-0]/, '##'],
      expireMask: [/[0-1]/, /[0-2]/, '.##'],
    }
  },
  created() {
    this.selectedDates = {...this.savedDates};
    if (!this.expireDates.length) this.addNewDate();
    this.updateSavedStatus();
  },
  watch: {
    // expireDates() {
    // console.log('ex dates updated', this.expireDates);
    // }
  },
  methods: {
    updateSavedStatus() {
      this.expireDates.forEach((d, i) => {
        this.$set(this.expireDates, i, {...d, saved: !!d.date, format_date: moment(d.date, 'MM.YYYY').format('MM.YY')});
      })
    },
    dateMask(v) {
      const months = [
        /[0-1]/,
        v.charAt(0) === '1' ? /[0-2]/ : /[0-9]/,
      ];
      const years = [/[0-9]/, /[0-9]/];
      return [...months, '.', ...years];
    },
    async selectNewDate(date) {
      this.selectedDates[date] = !this.selectedDates[date];
      this.selectedDates = {...this.selectedDates}
      const selectedDates = Object.keys(this.selectedDates).filter((k) => k && this.selectedDates[k]);
      const postData = {
        action: 'updateValidDates',
        invoice_id: this.invoiceId,
        invoices: this.invoices,
        revision_id: this.revisionId,
        drug_id: this.drugId,
        valid_dates: selectedDates
      };
      const {data} = await api.post('/invoices/details/update', postData)
      if (!data.success) {
        toastr['error'](data.message ?? 'Ошибка обновления даты', 'Ошибка');
        toastr['error'](postData, 'Ошибка');
      } else {
        if (this.updateDates) this.updateDates(this.selectedDates);
        toastr['success']('дата обновлена', 'Успешно');
      }
    },
    addNewDate() {
      this.expireDates.push({date: '', format_date: ''});
      // this.$set(this.expireDates, this.expireDates.length, {date: ''});
    },
    async updateRecord(action) {
      if (action === 'expireDate') {
        let pass = true;
        this.expireDates.forEach((e) => {
          if (!e.format_date) return;
          if (e.format_date.length !== 5) pass = false;
        })
        if (!pass) {
          toastr['warning']('срок годности введен не верно', 'Ошибка');
          return;
        }
        const duplicates = this.expireDates.filter((item, index, arr) => {
            // console.log(item.format_date);
            return arr.findIndex(obj => obj.format_date === item.format_date) !== index
          }
        );
        // console.log(this.expireDates, duplicates);
        if (duplicates.length) pass = false;
        if (!pass) {
          toastr['warning']('Найдены дубликаты срока годности', 'Ошибка');
          this.expireDates.pop();
          if (this.updateDates) {
            this.updateDates(this.expireDates.map((d) => {
              d.date = moment(d.expire_date).format('MM.YYYY');
              return d
            }));
          }
          return;
        }
      }
      this.expireDates.forEach((d) => {
        d.date = moment(d.format_date, 'MM.YY').format('MM.YYYY');
      });
      const {data} = await api.post('/stores/updateRevision', {
        action,
        invoice_id: this.invoiceId,
        revision_id: this.currentRevision?.id,
        drug_id: this.drugId,
        drugData: {expireDates: this.expireDates}
      })
      if (data.success) {
        if (this.updateDates) {
          this.updateDates(data.records.map((d) => {
            d.date = moment(d.expire_date).format('MM.YYYY');
            return d
          }));
        }
        this.updateSavedStatus();
        toastr['success']('обновлено', 'Успешно');
        if (this.updateDates) this.updateDates();
      }
    },
  }
}

</script>

<style scoped>
.input-group button,
input.form-control {
  font-size: 12px;
  line-height: 14px;
  height: 24px;
}
</style>
